export const GET_CAR_ENGINES_REQUEST = "GET_ENGINES_REQUEST";
export const GET_CAR_ENGINES_SUCCESS = "GET_ENGINES_SUCCESS";

export const SHOW_CAR_ENGINE_REQUEST = "SHOW_ENGINE_REQUEST";
export const SHOW_CAR_ENGINE_SUCCESS = "SHOW_ENGINE_SUCCESS";

export const SHOW_CAR_ENGINES_REQUEST = "SHOW_ENGINES_REQUEST";
export const SHOW_CAR_ENGINES_SUCCESS = "SHOW_ENGINES_SUCCESS";

export const POST_CAR_ENGINE_REQUEST = "POST_ENGINE_REQUEST";
export const POST_CAR_ENGINE_SUCCESS = "POST_ENGINE_SUCCESS";

export const PUT_CAR_ENGINE_REQUEST = "PUT_ENGINE_REQUEST";
export const PUT_CAR_ENGINE_SUCCESS = "PUT_ENGINE_SUCCESS";

export const DELETE_CAR_ENGINE_REQUEST = "DELETE_ENGINE_REQUEST";
export const DELETE_CAR_ENGINE_SUCCESS = "DELETE_ENGINE_SUCCESS";
